import {
  ArcElement,
  CategoryScale,
  Chart,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Title,
  Tooltip
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React from "react";
import { Doughnut } from "react-chartjs-2";

Chart.register(
  LineController,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  CategoryScale,
  ArcElement,
  ChartDataLabels,
  Tooltip
);
// Data needs to be in format //[{label:"", data: 1, color:""}]
function DoughnutChart({ data }) {
  const [chartData, setChartData] = React.useState({
    labels: [],
    datasets: [],
  });
  React.useEffect(() => {
    if (data && data.length > 0) {
      let labels = [];
      let dataset = { data: [], backgroundColor: [] };
      for (let d of data) {
        labels.push(d.label);
        dataset.data.push(d.data);
        dataset.backgroundColor.push(d.color);
      }
      setChartData({ labels, datasets: [dataset] });
    }
  }, [data]);
  return (
    <Doughnut
      data={chartData}
      options={{
        responsive: true,
        maintainAspectRatio: false,
        dataLabels: {
          visible: true,
          font: {
            color: "#FFFFFF",
            style: "Montserrat",
          },
        },
        plugins: {
          datalabels: {
            display: true,
            clamp: "true",
            color: "#FFFFFF",
            font: {
              weight: 600,
              style: "Montserrat",
            },
          },
          tooltips: {
            enabled: true,
          },
          legend: {
            display: false,
          },
        },
      }}
    />
  );
}

export default DoughnutChart;
